import SecuritySettings from '../../components/profile/SecuritySettings';
import { callAuthAPI } from '../../utils/apiUtils';
import { ROUTE_BACK_OFFICE_CHANGE_PASSWORD } from '../../constants';
import * as apiConstants from '../../utils/apiUtilsConstants';

const boToggleTwoFactor = async (enabled) => {
  return callAuthAPI('bo/user/toggle-2fa', { enable: enabled }, apiConstants.METHOD_POST, true);
};

const BackOfficeSettings = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h2>Settings</h2>
      <SecuritySettings
        changePasswordRoute={ROUTE_BACK_OFFICE_CHANGE_PASSWORD}
        toggleTwoFactorFn={boToggleTwoFactor}
        isTwoFactorLocked={true}
        twoFactorLockedText="Two-factor authentication is mandatory for back office accounts."
      />
    </div>
  );
};

export default BackOfficeSettings;